import { Component, inject, ViewChild, AfterViewInit, OnInit, OnDestroy } from '@angular/core';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { Subject, debounceTime } from 'rxjs';
import { DisbursmentService } from 'src/app/shared/service/disbursment/disbursment.service';
import { ConfirmationDialogComponent } from '../dis-repository/pages/create-port-tariff/confirmation-dialog.component';
import {
  Disbursment,
  columnsToDisplay,
  DisbursmentDetails,
  ColumnsTodisplayInExportData,
  formatDate,
} from './disbursment.component.model';
import { DisbursementService } from 'src/app/shared/service/disbursment/disbursement.component.service';
import { ExcelExportService } from 'src/app/shared/service/disbursment/excel-export.service';
import { PdfExportService } from 'src/app/shared/service/disbursment/pdf-export.service';
import { DisbursmentFilterComponent } from './disbursment-filter/disbursment-filter.component';
import { DisplayColumnDialogComponent } from './display-column-dialog/display-column-dialog.component';
import { FloatingFileViewerComponent } from 'src/app/shared/components/floating-file-viewer/floating-file-viewer.component';
import { Overlay, OverlayRef } from '@angular/cdk/overlay';
import { ComponentPortal } from '@angular/cdk/portal';
import { RequestFormService } from 'src/app/shared/service/requestForm/request-form.service';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { PageEvent } from '@angular/material/paginator';
import { DashboardRequest } from '../dis-dashboard.component.model';

@Component({
  selector: 'app-disbursment',
  templateUrl: './disbursment.component.html',
  styleUrls: ['./disbursment.component.scss'],
})
export class DisbursmentComponent implements OnInit, AfterViewInit, OnDestroy {
  // Use setter to capture MatSort as soon as the DOM renders *ngIf="data.length > 0"
  private sort!: MatSort;
  @ViewChild(MatSort) set matSort(ms: MatSort) {
    if (ms) {
      this.sort = ms;
      this.attachSort();
    }
  }

  private overlay = inject(Overlay);
  private overlayRef: OverlayRef | null = null;

  username: any;
  searchTerm: string = '';
  allDataLoaded = false;
  isLoading: boolean = true;
  // Converted to MatTableDataSource for client-side sorting
  dataSource = new MatTableDataSource<Disbursment>([]);
  
  columnsToDisplay = columnsToDisplay;
  columnsToDisplayOnly = this.columnsToDisplay.map((col) => col.property);
  expandedElement: Disbursment | null = null;
  disbursementdetails: DisbursmentDetails = new DisbursmentDetails({});
  isExpandedVal: boolean = false;
  preventScroll: boolean = false;

  currentPage = 1;
  pageSize = 50;
  totalCount = 0;
  appliedFilters: any = null;
  tooltipData: {
    text: string;
    x: number;
    y: number;
    tooltipClass?: string;
  } | null = null;
  private searchSubject = new Subject<string>();
  roleId: number = 0;
  ColumnsTodisplayInExportData = ColumnsTodisplayInExportData;
  subusername: any;
statusOptions: string[] = ['Completed', 'Pending'];
searchSuggestions: string[] = [];
Math = Math;

  // Add or verify your overallProgress object structure
  overallProgress = {
    pdaCompleted: { value: 0, total: 0 },
    pdaUnderProcess: { value: 0, total: 0 },
    fdaCompleted: { value: 0, total: 0 },
    fdaUnderProcess: { value: 0, total: 0 },
    fdaYetToReceive: { value: 0, total: 0 }
  };
  clientControl:any;
  clients:any;
  companyId:any;
  constructor(
    private disbursementService: DisbursementService,
    private snackbar: ToastrService,
    private dialog: MatDialog,
    private router: Router,
    private excelExportService: ExcelExportService,
    private pdfExportService: PdfExportService,
    private requestFormService: RequestFormService,
    private route: ActivatedRoute,
    private dashboardService: DisbursmentService
  ) {
    this.searchSubject.pipe(debounceTime(1000)).subscribe(() => {
      this.onSearch();
    });
    this.route.queryParams.subscribe((params) => {
      const id = params['id'];
      console.log('Received ID:', id);
    });
  }

  ngOnInit() {
    this.username = localStorage.getItem('username') ?? '';
    this.subusername = localStorage.getItem('loginPic') ?? '';
    if (this.username === 'Meraki - Operations') {
      this.roleId = 1;
    } else {
      this.roleId = 3;
    }

    this.columnsToDisplay = this.columnsToDisplay.filter((column: any) =>
      column.access.includes(this.roleId)
    );
    this.columnsToDisplayOnly = this.columnsToDisplay.map(
      (col) => col.property
    );

    // Define custom sorting accessor before data arrives
    this.setupSortingAccessor();
    this.loadOverallProgressData();
    this.route.queryParams.subscribe((params) => {
      const id = params['id'];

      if (id) {
        this.searchTerm = id;
        this.inputSearch();
      } else {
        this.getDisbursmentDataFromDb(true);
      }
    });
  }
  private getDynamicClientId(): ( number)[] | null {
  // Client Users (Role ID 3): Get companyId stored during login/verification
  if (this.roleId === 3) {
    const companyId = sessionStorage.getItem('companyId') || this.companyId;
    return companyId ? [Number(companyId)] : null;
  }

  // Operations / Admin Users: Check if a specific client is selected in the control/dropdown
  if (this.clientControl?.value) {
    const selectedClient = this.clients?.find(
      (client:any) => client.name === this.clientControl.value
    );
    return selectedClient ? [Number(selectedClient.id)] : null;
  }

  // Default: Return null to fetch overall metrics across all accessible clients
  return null;
}
loadOverallProgressData() {
  const dynamicClientId = this.getDynamicClientId();
    const dashboardRequest: DashboardRequest = {
      clientId: dynamicClientId,
      monthRange: { from_date: null, to_date: null },
      yearRange: { from_year: null, to_year: null },
    };

    this.dashboardService.getDashboardData(dashboardRequest).subscribe({
      next: (response: any) => {
        if (response?.overallSummary?.overallProgress) {
          const progress = response.overallSummary.overallProgress;
          
          this.overallProgress = {
            pdaCompleted: {
              value: progress.pda?.Completed ?? 0,
              total: progress.pda?.total ?? 0,
            },
            pdaUnderProcess: {
              value: progress.pda?.Underprogress ?? 0,
              total: progress.pda?.total ?? 0,
            },
            fdaCompleted: {
              value: progress.fda?.Completed ?? 0,
              total: progress.fda?.total ?? 0,
            },
            fdaUnderProcess: {
              value: progress.fda?.Underprogress ?? 0,
              total: progress.fda?.total ?? 0,
            },
            fdaYetToReceive: {
              value: progress.fda?.yetToProcess ?? 0,
              total: progress.pda?.pdaCompletedNoFda ?? 0,
            },
          };
        }
      },
      error: (error: any) => {
        console.error('Error fetching overall progress data:', error);
      },
    });
  }
  ngAfterViewInit() {
    this.attachSort();
  }

  /** Binds MatSort to MatTableDataSource securely */
  private attachSort() {
    if (this.sort && this.dataSource) {
      this.dataSource.sort = this.sort;
      // Force change detection update on the data source
      this.dataSource._updateChangeSubscription();
    }
  }

  /** Custom Sorting Accessor for Currency, Numbers, Dates, and Case-Insensitive Strings */
  private setupSortingAccessor() {
    this.dataSource.sortingDataAccessor = (item: any, property: string) => {
      const value = item[property];

      if (value === null || value === undefined || value === '') {
        return '';
      }

      // Handle numerical & currency amounts
      if (this.isAmountColumn(property)) {
        const numericStr = String(value).replace(/[^0-9.-]+/g, '');
        const parsed = parseFloat(numericStr);
        return isNaN(parsed) ? 0 : parsed;
      }

      // Handle strings (case-insensitive)
      if (typeof value === 'string') {
        return value.toLowerCase();
      }

      return value;
    };
  }

  ngOnDestroy() {
    this.searchSubject.complete();
  }
onSearchInput(event: Event): void {
    const value = (this.searchTerm || '').trim().toLowerCase();

    if (value) {
      // Filter status options matching typed input
      this.searchSuggestions = this.statusOptions.filter((option) =>
        option.toLowerCase().includes(value)
      );
    } else {
      this.searchSuggestions = [];
    }

    // Call your existing search trigger
    this.inputSearch();
  }
  onSuggestionSelected(event: any): void {
    this.searchTerm = event.option.value;
    this.searchSuggestions = [];
    this.onSearch(); // Executes immediate search for the selected status
  }
  inputSearch(): void {
    this.searchSubject.next(this.searchTerm);
  }

  /** Fetches disbursement data from the database. */
getDisbursmentDataFromDb(reset = false) {
  this.isLoading = true;
  if (reset) {
    this.currentPage = 1;
    this.dataSource.data = [];
    this.totalCount = 0;
    this.allDataLoaded = false;
  }

  const body: any = {
    query: this.searchTerm.trim(),
    page: this.currentPage,
    page_size: this.pageSize,
  };

  if (this.appliedFilters && this.appliedFilters.filter) {
    body.filter = this.appliedFilters.filter;
  }

  this.disbursementService.getDisbursementData(body).subscribe({
    next: (response: { data: Disbursment[]; total_count: number }) => {
      const responseData = this.maskDemoDisbursementData(response.data);
      this.totalCount =
        this.username?.toLowerCase() === 'demo'
          ? responseData.length
          : response.total_count;

      const mappedData = responseData.map((item: any) => {
        const pdaSavings = Number(item.pda_savings) || 0;
        const fdaSavings = Number(item.fda_savings) || 0;
        return {
          ...item,
          vessel_name: item.vessel_name ? item.vessel_name.toUpperCase() : '',
          total_savings: pdaSavings + fdaSavings,
          eta: formatDate(item.eta),
          etd: formatDate(item.etd),
          due_comment: item.due_comment || '',
          due_color: item.due_color || '',
          created_on: formatDate(item.created_on),
          fda_completed_date: formatDate(item.fda_completed_date),
          agency_nomination_date: formatDate(item.agency_nomination_date) || formatDate(item.created_on),
        };
      });

      // Assign page data directly (do not append)
      this.dataSource.data = mappedData;
      this.attachSort();
      this.isLoading = false;
    },
    error: (error) => {
      console.error('Error fetching disbursement data:', error);
    },
  });
}

// Add page change handler for mat-paginator
onPageChange(event: PageEvent): void {
  this.currentPage = event.pageIndex + 1;
  this.pageSize = event.pageSize;
  if (this.roleId === 3) {
    this.getClientDisbursmentDataFromDb();
  } else {
    this.getDisbursmentDataFromDb();
  }
}

  getClientDisbursmentDataFromDb(reset = false) {
    this.isLoading = true;
    if (reset) {
      this.currentPage = 1;
      this.dataSource.data = [];
      this.totalCount = 0;
      this.allDataLoaded = false;
    }

    const body: any = {
      query: this.searchTerm.trim(),
      page: this.currentPage,
      page_size: this.pageSize,
    };

    if (this.appliedFilters && this.appliedFilters.filter) {
      body.filter = this.appliedFilters.filter;
    }

    this.disbursementService.getClientDisbursementData(body).subscribe({
      next: (response: { data: Disbursment[]; total_count: number }) => {
        this.totalCount = response.total_count;

        const mappedData = response.data.map((item) => ({
          ...item,
          eta: formatDate(item.eta),
          etd: formatDate(item.etd),
          due_comment: item.due_comment || '',
          due_color: item.due_color || '',
        }));

        this.dataSource.data = [...this.dataSource.data, ...mappedData];

        // Ensure sort binding persists when data updates
        this.attachSort();

        if (this.dataSource.data.length >= this.totalCount) {
          this.allDataLoaded = true;
        }

        this.currentPage++;
        this.isLoading = false;
      },
      error: (error) => {
        console.error('Error fetching disbursement data:', error);
      },
    });
  }

  handleDisbursementChange(updatedDisbursement: DisbursmentDetails) {
    this.disbursementService
      .disbursementDataToDb(updatedDisbursement)
      .subscribe({
        next: (response) => {
          this.snackbar.success(response.message);
        },
        error: (error) => {
          this.snackbar.error('Error updating disbursement details');
        },
      });
  }

  isExpanded(element: Disbursment) {
    return this.expandedElement === element;
  }

  toggle(element: Disbursment) {
    if (this.roleId !== 3 && this.subusername !== 'demo') {
      const wasExpanded = this.isExpanded(element);
      this.expandedElement = wasExpanded ? null : element;
      this.isExpandedVal = !wasExpanded;
    }
  }

  onSearch() {
    this.appliedFilters = null;
    this.getDisbursmentDataFromDb(true);
  }

  clearSearch() {
    this.searchTerm = '';
    this.appliedFilters = null;
    this.getDisbursmentDataFromDb(true);
  }

  onManualScroll(): void {
    const scrollContainer = document.querySelector('.table-container');
    if (scrollContainer) {
      const scrollPosition =
        scrollContainer.scrollTop + scrollContainer.clientHeight;
      const scrollHeight = scrollContainer.scrollHeight;

      if (scrollPosition >= scrollHeight - 10 && !this.allDataLoaded) {
        if (this.roleId === 3) {
          this.getDisbursmentDataFromDb();
        } else {
          this.getDisbursmentDataFromDb();
        }
      }
    }
  }

  viewLess() {
    this.isExpandedVal = false;
    this.expandedElement = null;
  }

  navigateToPda() {
    this.router.navigate(['/dis-pda']);
  }

  navigateToFda() {
    this.router.navigate(['/dis-fda']);
  }

  openFilterDialog() {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.position = { right: '0' };
    dialogConfig.height = '100%';
    dialogConfig.width = '45vw';
    dialogConfig.maxWidth = '45vw';
    dialogConfig.panelClass = ['animate__animated', 'animate__slideInRight'];
    dialogConfig.hasBackdrop = true;
    dialogConfig.data = {};
    const dialogRef = this.dialog.open(
      DisbursmentFilterComponent,
      dialogConfig
    );

    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        this.applyFiltersAndRefresh(result);
      }
    });
  }

  applyFiltersAndRefresh(filters: any) {
    this.appliedFilters = filters;
    this.getDisbursmentDataFromDb(true);
  }

  openColumnDialog() {
    const dialogRef = this.dialog.open(DisplayColumnDialogComponent, {
      disableClose: true,
      panelClass: 'email-dialog-style',
      width: '70vw',
      maxWidth: '95vw',
      height: '500px',
      data: {
        columns: this.ColumnsTodisplayInExportData,
        pdfExportService: this.pdfExportService,
      },
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        const body: any = {
          query: this.searchTerm.trim(),
          page: this.currentPage,
          page_size: this.pageSize,
        };

        if (this.appliedFilters && this.appliedFilters.filter) {
          body.filter = this.appliedFilters.filter;
        }
        this.disbursementService.getDisbursementDataToExport(body).subscribe({
          next: (response: any) => {
            let data = response?.data || response;
            data = this.formatDateFields(data);
            if (result.exportType === 'excel') {
              this.excelExportService.exportToExcel(
                result.columns,
                data,
                result.applyCss,
                'Disbursement_List'
              );
            } else if (result.exportType === 'pdf') {
              this.pdfExportService.exportToPdf(
                result.columns,
                data,
                result.applyCss,
                'Disbursement_List'
              );
            }
          },
          error: (error) => {
            console.error('Error exporting data:', error);
            this.snackbar.error('Failed to export data');
          },
        });
      }
    });
  }

 showFilePreview(element: Disbursment, event: MouseEvent) {
  if (this.overlayRef) {
    this.overlayRef.dispose();
    this.overlayRef = null;
  }

  const positionStrategy = this.overlay
    .position()
    .global()
    .centerHorizontally()
    .centerVertically();

  this.overlayRef = this.overlay.create({
    positionStrategy,
    hasBackdrop: true,
    backdropClass: 'cdk-overlay-dark-backdrop',
    scrollStrategy: this.overlay.scrollStrategies.block(),
  });

  this.overlayRef.backdropClick().subscribe(() => {
    this.hideFilePreview();
  });

  const portal = new ComponentPortal(FloatingFileViewerComponent);
  const componentRef = this.overlayRef.attach(portal);

  // Bind values to FloatingFileViewerComponent
  componentRef.instance.disbursementSeq = element.disbursement_seq;
  componentRef.instance.disbursementId = element.disbursement_id;
  componentRef.instance.disbursementObj = element; // <-- Pass disbursement object

  const closeSub = componentRef.instance.close.subscribe(() => {
    this.hideFilePreview();
    closeSub.unsubscribe();
  });
}

  hideFilePreview() {
    if (this.overlayRef) {
      this.overlayRef.dispose();
      this.overlayRef = null;
    }
  }

  showTooltip(element: Disbursment, event: MouseEvent) {
    if (element.due_comment && element.due_comment !== '') {
      const rect = (event.target as HTMLElement).getBoundingClientRect();
      this.tooltipData = {
        text: element.due_comment,
        x: rect.right + 10,
        y: rect.top,
      };
    }
  }

  hideTooltip() {
    this.tooltipData = null;
  }

  formatDateFields(
    data: any[],
    dateFields: string[] = [
      'agency_nomination_date',
      'pda_processing_date',
      'fda_processing_date',
      'eta',
      'etd',
      'fda_receive_date',
      'pda_receive_date',
    ]
  ): any[] {
    return data.map((row: any) => {
      const newRow = { ...row };
      dateFields.forEach((field) => {
        if (newRow[field]) newRow[field] = formatDate(newRow[field]);
      });
      return newRow;
    });
  }

  onDelete(element: Disbursment, type: string) {
    const PDAORFDA = element.fda_id && element.fda_state != 'D' ? 'FDA' : 'PDA';
    const showCheckbox = element.pda_status.toLowerCase().includes('request');
    const status = PDAORFDA === 'PDA' ? element.pda_status : element.fda_status;
    const dialogRef = this.dialog.open(ConfirmationDialogComponent, {
      disableClose: true,
      panelClass: 'sweet-alert-style',
      data: {
        header: `Confirm ${type === 'delete' ? 'Delete' : 'InActive'}`,
        text:
          type === 'delete'
            ? `Are you sure you want to delete the ${PDAORFDA} for Disbursement ID: ${element.disbursement_id} with status: ${status}?   This action cannot be undone.`
            : `Are you sure you want to inactivate the ${PDAORFDA} for Disbursement ID:  ${element.disbursement_id} and status:${status}?`,
        showCheckbox: showCheckbox,
        checkboxText: 'confirm the deletion',
      },
    });
    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        this.deleteOrInActivateRecord(element, type);
      }
    });
  }

  deleteOrInActivateRecord(element: Disbursment, type: string) {
    const params = {
      disbursement_seq: element.disbursement_seq,
      pda_id: element.pda_id,
      fda_id: element.fda_id,
      state: type === 'delete' ? 'D' : 'N',
    };
    this.disbursementService.deleteOrInActivateDisbursement(params).subscribe({
      next: (response) => {
        this.snackbar.success(response.message);
        if (this.roleId === 3) {
          this.getClientDisbursmentDataFromDb(true);
        } else {
          this.getDisbursmentDataFromDb(true);
        }
      },
      error: (error) => {
        this.snackbar.error(error.message);
      },
    });
  }

  isDarkMode() {
    return this.requestFormService.isDarkMode();
  }

  editingCell: {
    disbursement_seq: any;
    field: string;
  } | null = null;

  editValue: any = '';

  startEditing(element: any, field: string, event: MouseEvent): void {
    event.stopPropagation();

    if (this.roleId !== 3) {
      return;
    }

    this.editingCell = {
      disbursement_seq: element.disbursement_seq,
      field: field,
    };

    this.editValue = element[field] ?? '';
  }

  isEditing(element: any, field: string): boolean {
    return (
      this.editingCell?.disbursement_seq === element.disbursement_seq &&
      this.editingCell?.field === field
    );
  }

  saveCellValue(element: any, field: string, valueOrEvent: any): void {
    let newValue: any;

    if (valueOrEvent instanceof Event) {
      valueOrEvent.stopPropagation();
      const input = valueOrEvent.target as HTMLInputElement;
      newValue = input.value;
    } else {
      newValue = valueOrEvent;
    }

    const request = {
      disbursement_seq: element.disbursement_seq,
      [field]: newValue,
    };

    this.disbursementService.updateDashboardRow(request).subscribe({
      next: (response) => {
        element[field] = newValue;
        this.snackbar.success(
          response?.message || 'Value updated successfully'
        );
        this.editingCell = null;
        this.editValue = '';
      },
      error: (error) => {
        console.error('Error updating dashboard row:', error);
        this.snackbar.error(
          error?.error?.message || 'Failed to update value'
        );
      },
    });
  }

  selectRemarkSuggestion(value: string, event: MouseEvent): void {
    event.stopPropagation();
    this.editValue = value;
  }

  private maskDemoDisbursementData(data: Disbursment[]): Disbursment[] {
    if (this.subusername?.toLowerCase() !== 'demo') {
      return data;
    }

    return data
      .filter(
        (item: any) =>
          String(item.vessel ?? item.vessel_name ?? '')
            .trim()
            .toLowerCase() === 'llevant'
      )
      .map((item: any) => ({
        ...item,
        vessel: 'Vessel 1',
        vessel_name: 'Vessel 1',
        client: 'Client 1',
        client_name: 'Client 1',
      }));
  }

  formatAmount(value: any): string {
    if (value === null || value === undefined || value === '') {
      return '-';
    }

    const valueStr = String(value).trim();
    const currencyMatch = valueStr.match(
      /^([A-Za-z]{3})\s*([-+]?\d+(?:\.\d+)?)$/
    );

    if (currencyMatch) {
      const currency = currencyMatch[1];
      const amount = Number(currencyMatch[2]);

      return `${currency} ${amount.toLocaleString('en-IN', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      })}`;
    }

    const amount = Number(valueStr);

    if (!isNaN(amount)) {
      return amount.toLocaleString('en-US', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      });
    }

    return value;
  }

  isAmountColumn(property: string): boolean {
    return [
      'advance_amount_remitted',
      'outstanding_balance',
      'pda_savings',
      'fda_savings',
      'total_savings',
      'pda_amount',
      'fda_amount',
      'advance_amount',
      'final_amount',
      'manual_pda_amount',
      'manual_fda_amount',
    ].includes(property);
  }

  isEditAllowed(element: any): boolean {
    const pdaCompleted = element.pda_status
      ?.toLowerCase()
      .includes('completed');
    const fdaCompleted = element.fda_status
      ?.toLowerCase()
      .includes('completed');

    return !pdaCompleted && !fdaCompleted;
  }

  onEdit(element: any, event: MouseEvent): void {
    event.stopPropagation();

    if (!this.isEditAllowed(element)) {
      return;
    }

    this.router.navigate(['/dis-request-form'], {
      queryParams: { id: element.disbursement_id },
    });
  }
  onSearchFocus(): void {
  this.updateSearchSuggestions(this.searchTerm);
}

updateSearchSuggestions(searchTerm: string): void {
  const term = (searchTerm || '').toLowerCase().trim();
  const options = [...this.statusOptions];

  if (!term) {
    this.searchSuggestions = options;
  } else {
    this.searchSuggestions = options.filter((opt) =>
      opt.toLowerCase().includes(term)
    );
  }
}
clearSearchInput(event: MouseEvent): void {
  event.stopPropagation();
  this.searchTerm = '';
  this.searchSuggestions = [];
  this.onSearch();
}
}